import {
  getProperties,
  getPropertiesSuites,
  getPropertySuitesForTable,
  getServiceProviderProperties,
} from 'src/services/client';

// Fetches properties from the API for the given user.
const retrievePropertiesFromApi = async (user: any): Promise<any> => {
  try {
    const propertiesResponse: any = await getProperties(
      user.id,
      user.roles[0].role.name
    );

    if (!propertiesResponse || !propertiesResponse.ok) {
      return console.error(
        'Failed to fetch home owner properties:',
        propertiesResponse
      );
    }

    const propertiesFromApi: any = await propertiesResponse.json();
    return propertiesFromApi?.data || [];
  } catch (error) {
    console.error('Unexpected error in retrievePropertiesFromApi:', error);
    throw error;
  }
};

// Fetches suites for multiple properties.
const retrievePropertiesSuitesFromApi = async (params: any): Promise<any> => {
  try {
    const suitesResponse: any = await getPropertiesSuites(params);

    if (!suitesResponse || !suitesResponse.ok) {
      console.error('Failed to fetch property suites:', suitesResponse);
      return [];
    }

    const suitesData: any = await suitesResponse.json();
    return suitesData || [];
  } catch (error) {
    console.error('Error in retrievePropertiesSuitesFromApi:', error);
    return [];
  }
};

const retrievePropertySuitesFromApiByRole = async (id, userId, role) => {
  try {
    const response: any = await getPropertySuitesForTable(id, userId, role);

    if (!response.ok) {
      console.error(
        'Failed to fetch service provider properties:',
        response.status
      );
      return [];
    }

    const responseJson: any = await response.json();
    return responseJson || [];
  } catch (error) {
    console.error('Error in retrievePropertySuitesFromApi:', error);
    return [];
  }
};

// Fetches properties assigned to a service provider.
const retrieveServiceProviderPropertiesFromApi = async (
  contactId: string
): Promise<any> => {
  try {
    const response: any = await getServiceProviderProperties(contactId);

    if (!response.ok) {
      console.error(
        'Failed to fetch service provider properties:',
        response.status
      );
      return [];
    }

    const responseJson: any = await response.json();
    return responseJson.data || [];
  } catch (error) {
    console.error('Error in retrieveServiceProviderPropertiesFromApi:', error);
    return [];
  }
};

export {
  retrievePropertiesFromApi,
  retrievePropertySuitesFromApiByRole,
  retrieveServiceProviderPropertiesFromApi,
  retrievePropertiesSuitesFromApi,
};
